import React, { useEffect, useState } from 'react';
import {
  View, Image, TextInput, ScrollView,
} from 'react-native';
import { TextInputMask } from 'react-native-masked-text';
import Icon from 'react-native-vector-icons/Ionicons';
import { useDispatch, useSelector } from 'react-redux';

import logo_purple from '../../../assets/images/logo_purple.png';
import { AppHeader } from '../../../components/common';
import { AppButton, AppText } from '../../../components/form';
import { UserActions } from '../../../redux/reducers/userReducer';
import { styles } from './styles';

const SignUpTrainer = ({ navigation }) => {
  const { userSignUp } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: UserActions.UPDATE_SIGNUP,
      userSignUp: {
        ...userSignUp, nome: '', cpf: '', telefone: '', email: '', senha: '',
      },
    });
  }, []);
  const [visiblePass, setVisiblePass] = useState(false);
  const verifyBlanks = () => (
    userSignUp.nome === '' || userSignUp.cpf === '' || userSignUp.telefone === '' || userSignUp.email === '' || userSignUp.senha === ''
  );
  const next = () => {
    const isGroup = userSignUp.group_qnt > 1;
    navigation.navigate('Profile Trainer', { screen: isGroup ? 'Grupo' : 'Selecione os Objetivos' });
  };
  return (
    <>
      <AppHeader navigation={navigation} hasBack title="Cadastro" />
      <ScrollView style={styles.card}>
        <Image style={styles.logo} source={logo_purple} />
        <AppText size="bold" style={styles.textTitle}>{'Cadastre-se para\ncontinuar sua compra'}</AppText>
        <View style={styles.viewForm}>
          <View>
            <TextInput placeholder="Nome" style={styles.input} value={userSignUp.nome} onChangeText={(nome) => dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, nome } })} />
            <Icon name="person-outline" style={styles.inputIcon} />
          </View>
          <View>
            <TextInputMask type="cpf" value={userSignUp.cpf} onChangeText={(cpf) => dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, cpf } })} placeholder="CPF" keyboardType="number-pad" style={styles.input} />
            <Icon name="person-outline" style={styles.inputIcon} />
          </View>
          <View>
            <TextInputMask type="cel-phone" placeholder="Telefone" keyboardType="phone-pad" style={styles.input} value={userSignUp.telefone} onChangeText={(telefone) => dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, telefone } })} />
            <Icon name="call-outline" style={styles.inputIcon} />
          </View>
          <View>
            <TextInput placeholder="E-Mail" keyboardType="email-address" style={styles.input} value={userSignUp.email} onChangeText={(email) => dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, email } })} />
            <Icon name="mail-outline" style={styles.inputIcon} />
          </View>
          <View>
            <TextInput placeholder="Senha" secureTextEntry={!visiblePass} style={styles.input} value={userSignUp.senha} onChangeText={(senha) => dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, senha } })} />
            <Icon name="settings-outline" style={styles.inputIcon} />
            <Icon name={visiblePass ? 'eye-off' : 'eye'} onPress={() => setVisiblePass(!visiblePass)} style={[styles.inputIcon, styles.inputIconEye]} />
          </View>
          <AppButton
            disabled={verifyBlanks()}
            onPress={() => next()}
            style={styles.button}
            labelStyle={styles.textButton}
            label="Continuar"
          />
        </View>
      </ScrollView>
    </>
  );
};

export default SignUpTrainer;
